import * as actionTypes from "./constants";
const initialState = {
  kWhotelUserId: 0,
  username: "",
  password: "",
  syncHotelId: "",
  hotels: [],
  selected: [],
  fetching: false,
  fetched: false,
  scheduledJob: undefined
};

const syncReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_SYNC_HOTEL_ID:
      return {
        ...state,
        syncHotelId: action.syncHotelId
      };
    case actionTypes.SET_SYNC_USERNAME:
      return {
        ...state,
        username: action.username
      };
    case actionTypes.SET_SYNC_PASSWORD:
      return {
        ...state,
        password: action.password
      };
    case actionTypes.SELECT_HOTEL:
      return {
        ...state,
        selected: state.hotels.filter(hotel =>
          action.selected.find(selectedId => hotel.id === selectedId)
        )
      };

    case actionTypes.SET_LOGIN:
      return {
        ...state,
        username: action.login
      };

    case actionTypes.SET_PASSWORD:
      return {
        ...state,
        password: action.password
      };
    case actionTypes.AUTHENTICATE_SYNC_USER_REQUEST:
      return {
        ...state,
        fetching: true,
        fetched: false
      };

    case actionTypes.AUTHENTICATE_SYNC_USER_SUCCESS:
      return {
        ...state,
        fetching: state.hotels.length > 0,
        hotels: action.hotels
      };

    case actionTypes.SYNC_USER_SUCCESS:
      return {
        ...state,
        ...action.syncUser
      };

    case actionTypes.GET_SYNC_USER_SUCCESS:
      return {
        ...state,
        ...action.payload
      };
    case actionTypes.SYNC_ROOMS_SUCCESS:
      return {
        ...state,
        fetching: false,
        fetched: true
      };
    case actionTypes.SCHEDULE_GETTING_ROOM_INFO:
      return {
        ...state,
        scheduledJob: action.payload
      };

    case actionTypes.AUTHENTICATE_SYNC_USER_REJECT:
    case actionTypes.SYNC_HOTEL_REJECT:
    case actionTypes.SYNC_ROOM_GROUPS_REJECT:
    case actionTypes.SYNC_ROOMS_REJECT:
      return {
        ...state,
        fetching: false,
        fetched: false
      };

    default:
      return state;
  }
};

export default syncReducer;



// WEBPACK FOOTER //
// ./src/synchronization/reducer.js